module Meevo.Plugins.MerchantAccounts {
    "use strict";

    /**
    * Devices Section of Merchant Account 
    */
    export class DevicesSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.MerchantAccount> {
        customAuditCriteria = {
            nounId: Model.NounEnum.MerchantAccountDevices,
        };

        constructor(sectionId: number, displayNameContentKey: string, template: string, isPrimarySection: boolean,
            handlesOwnCrud: boolean, baseEndpoint: string, sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            identityService: Meevo.Components.Common.IIdentityService,
            noun: Meevo.Model.NounEnum,
            protected modalService: Components.Modal.IModalService,
            sectionSecurityKey?: string) {

            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun, null, sectionSecurityKey);
            this.modalService = modalService;
        }

        unlockItem(item: any): void {
            let payload = {
                merchantAccountId: item.merchantAccountId,
                merchantTerminalId: item.id,
                serialNumber: item.serialNumber,
                externalTerminalId: item.externalTerminalId,
                lockedByUserId: item.lockedByUserId,
                lockedDateTime: item.lockedDateTime,
                lockVersion: item.lockVersion
            };
            this.dataService.customMethodData('api/MerchantTerminal/Unlock', 'POST', payload)
                .then((data: any) => {
                    item.hasLockForProcessing = false;
                    this.modalService.alert(`The terminal ${item.displayName} has been unlocked.`);
                });
        }
    }
}